export default __webpack_public_path__ + "static/media/Account_profile_msg.c1b1ab9a.svg";